<hc-navbar appIcon="assets/images/igniteName.svg" brandIcon="assets/images/triflame.svg" homeUri="/" [fixedTop]="false">
    <hc-navbar-link
        uri="/home"
        *ngIf="hasHomeTabPermission$ | async"
        linkText="{{ defaultLandingTabName }}"
    ></hc-navbar-link>
    <hc-navbar-link *ngIf="hasDataTabPermission$ | async" uri="/data" linkText="Data"></hc-navbar-link>
    <hc-navbar-link *ngIf="hasPlatformTabPermission$ | async" uri="/platform" linkText="Platform"></hc-navbar-link>
    <hc-navbar-link *ngIf="hasAnyTenantAdminPermissions$ | async" uri="/admin" linkText="Admin"></hc-navbar-link>
    <hc-icon
        *ngIf="isGlobalAdmin"
        class="hc-navbar-icon global-admin-ico"
        fontIcon="icon-globe-2"
        tabindex="0"
        routerLink="/global-admin"
        routerLinkActive="active"
        title="Go to the global admin page"
    ></hc-icon>
    <hc-icon
        class="hc-navbar-icon cdp-fade-in"
        [class.cdp-new-indicator]="releaseNotesModalService.hasNewReleaseNotes"
        fontIcon="icon-help"
        [hcPop]="options"
        tabindex="0"
        title="Learn more about Ignite"
    ></hc-icon>
    <span class="hc-navbar-vertical-separator"></span>
    <div class="hc-navbar-username" [hcPop]="user" tabindex="0" title="User menu">
        <span>
            <span *ngIf="name$ | async as name">
                {{ name }}
            </span>
        </span>
        <hc-icon fontIcon="icon-chev-down"></hc-icon>
    </div>
    <div
        *ngIf="showTenantSwitcher"
        class="hc-navbar-username global-tenant-switcher"
        [hcPop]="tenantSwitcher"
        tabindex="0"
        [title]="tenantSwitcherTooltip"
    >
        <span class="tenant-code"> {{ tenantCode }} </span>
        <hc-icon fontIcon="icon-chev-down"></hc-icon>
    </div>
    <hc-navbar-cobrand *ngIf="tenantCobrandImg" color="light" [src]="sanitize(tenantCobrandImg)"></hc-navbar-cobrand>
</hc-navbar>
<cdp-clock></cdp-clock>
<hc-banner *ngIf="tenantIsInactive$ | async" type="info" clickDismiss="false">
    <span hcBannerStamp hcTooltip="">INFO</span>
    <span>{{ tenantCode }} is currently <strong>Inactive.</strong> </span>
    <span
        class="icon-info cdp-info-ico cdp-info-ico-right"
        [hcTooltip]="tooltips.tenantInactiveInfo"
        verticalAlign="below"
        maxWidth="350px"
    ></span>
</hc-banner>

<hc-pop #options [autoCloseOnContentClick]="true" [showArrow]="false" horizontalAlign="end">
    <div hcMenu>
        <a
            hcMenuItem
            href="https://docs.healthcatalyst.com/ignite/"
            target="_blank"
            title="Go to the official documentation for Ignite"
        >
            <span hcMenuIcon class="icon-book"></span>
            <span hcMenuText>Read the docs</span>
        </a>
        <a
            hcMenuItem
            href="https://healthcatalyst.atlassian.net/servicedesk/customer/portal/23"
            target="_blank"
            title="Ask a question on Health Catalyst Community"
        >
            <span hcMenuIcon class="icon-users"></span>
            <span hcMenuText>Get Help</span>
        </a>
        <button hcMenuItem (click)="openReleaseNotes()" title="Review release notes for the latest version of Ignite">
            <span
                hcMenuIcon
                class="icon-bullhorn"
                [class.cdp-new-indicator]="releaseNotesModalService.hasNewReleaseNotes"
            ></span>
            <span hcMenuText>What's new</span>
        </button>
        <a
            hcMenuItem
            href="https://docs.healthcatalyst.com/getting-started/articles/media/product-roadmaps.pdf"
            target="_blank"
            title="See an outline of scheduled feature development"
        >
            <span hcMenuIcon class="icon-map"></span>
            <span hcMenuText>Explore the roadmap</span>
        </a>
        <div hcMenuItem hcDivider></div>
        <a hcMenuItem href="http://healthcatalyst.com" target="_blank" title="Visit Health Catalyst's website">
            <span hcMenuIcon class="icon-triflame"></span>
            <span hcMenuText>HealthCatalyst.com</span>
        </a>

        <button hcMenuItem (click)="openAbout()">
            <span hcMenuIcon class="icon-info"></span>
            <span hcMenuText>About</span>
        </button>
    </div>
</hc-pop>

<hc-pop #user [autoCloseOnContentClick]="true" [showArrow]="false" horizontalAlign="end">
    <div hcMenu class="navbar-user-menu">
        <button hcMenuItem (click)="openUserDetail()">
            <span hcMenuIcon class="icon-user-circle"></span>
            <span hcMenuText>View user detail</span>
        </button>
        <button hcMenuItem (click)="toggleClock()">
            <span hcMenuIcon class="icon-clock{{ showingClock ? '-slash' : '' }}"></span>
            <span hcMenuText>{{ showingClock ? 'Hide' : 'Show' }} UTC clock</span>
        </button>

        @if (showDbxClearSessionButton) {
            <button hcMenuItem (click)="clearDbxSession()">
                <span class="icon-empty" hcMenuIcon></span>
                <span hcMenuText>Clear Databricks session tracking</span>
            </button>
        }
        <button hcMenuItem (click)="clearUserSession()">
            <span class="icon-empty" hcMenuIcon></span>
            <span hcMenuText>Clear user session</span>
        </button>
        <div hcMenuItem hcDivider></div>
        <button hcMenuItem (click)="logout()">
            <span hcMenuIcon class="icon-sign-out"></span>
            <span hcMenuText>Sign out</span>
        </button>
    </div>
</hc-pop>

<hc-pop #tenantSwitcher [showArrow]="false" [autoFocus]="true" (opened)="switcher.clearSearch()">
    <cdp-tenant-switcher #switcher (tenantSelected)="tenantSwitcher.close()"></cdp-tenant-switcher>
</hc-pop>
